//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class OnboardingElementIdentifiers
{
	public static destinationsIndexAddNewDestinationId: string = `destinationsIndexAddNewDestination`;
	public static tutorialsId: string = `tutorials`;
	public static companyProfileId: string = `companyProfile`;
	public static destinationsDetailOverviewBasicInformationEditCssClass: string = `destinationsDetailOverviewBasicInformationEdit`;
	public static destinationsDetailOverviewImagesEditButtonCssClass: string = `destinationsDetailOverviewImagesEdit`;
	public static destinationsDetailPlacesTabId: string = `places-tab`;
	public static destinationsDetailPlacesPoiDetailCssClass: string = `destinationsDetailPlacesPoiDetail`;
	public static destinationsDetailMapCreateNewPoiAlertCssClass: string = `destinationsDetailMapCreateNewPoiAlert`;
	public static destinationsDetailMapCreateNewPoiCssClass: string = `destinationsDetailMapCreateNewPoi`;
	public static destinationsDetailMapTabId: string = `map-tab`;
	public static destinationsDetailMapNewPoiMarkerCssClass: string = `destinationsDetailMapNewPoiMarker`;
	public static poiBasicInformationCssClass: string = `poiBasicInformation`;
	public static poiMediaCssClass: string = `poiMedia`;
	public static poiLocationCssClass: string = `poiLocation`;
	public static destinationsDetailPublishCssClass: string = `destinationsDetailPublish`;
	public static destinationsDetailImproveGuideCssClass: string = `destinationsDetailImproveGuide`;
	public static destinationsValidationCheckPreviewInAppCssClass: string = `destinationsValidationCheckPreviewInApp`;
	public static destinationsValidationCheckRequestPublishCssClass: string = `destinationsValidationCheckRequestPublish`;
	public static destinationsValidationCheckPublishCssClass: string = `destinationsValidationCheckPublish`;
	public static destinationsDetailToursTabId: string = `tours-tab`;
	public static tourDetailBasicInformationCssClass: string = `tourDetailBasicInformation`;
	public static tourDetailImageCssClass: string = `tourDetailImage`;
	public static tourDetailAdditionalInformationCssClass: string = `tourDetailAdditionalInformation`;
	public static tourDetailPoiSearchToAddToTourCssClass: string = `tourDetailPoiSearchToAddToTour`;
	public static tourDetailPoiToAddToTourFormCssClass: string = `tourDetailPoiToAddToTourForm`;
	public static tourDetailPoiDragAndDropCssClass: string = `tourDetailPoiDragAndDrop`;
	public static tourDetailAutoGenerateRouteCssClass: string = `tourDetailAutoGenerateRoute`;
	public static tourDetailSaveRoute: string = `tourDetailSaveRoute`;
	public static tourDetailIndoorTourLocationSaveCssClass: string = `tourDetailIndoorTourLocationSave`;
}
